module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "mainDiv"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "masterDraggie"
  }, [_c('div', {
    staticClass: "draggieContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voice1Div),
      expression: "voice1Div"
    }],
    staticClass: "voice1Draggable",
    class: _vm.voice1DivClass,
    attrs: {
      "id": "voice1DivID"
    },
    on: {
      "click": _vm.voice1DraggieClick
    }
  }, [_c('strong', [_c('p', {
    attrs: {
      "id": "voiceBubbleText"
    }
  }, [_vm._v("PART 1 ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceBubbleText2"
    }
  }, [_vm._v(" " + _vm._s(_vm.voice1CurrentInstrument) + " ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voice2Div),
      expression: "voice2Div"
    }],
    staticClass: "voice2Draggable",
    class: _vm.voice2DivClass,
    attrs: {
      "id": "voice2DivID"
    },
    on: {
      "click": _vm.voice2DraggieClick
    }
  }, [_c('strong', [_c('p', {
    attrs: {
      "id": "voiceBubbleText"
    }
  }, [_vm._v("PART 2 ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceBubbleText2"
    }
  }, [_vm._v(" " + _vm._s(_vm.voice2CurrentInstrument) + " ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voice3Div),
      expression: "voice3Div"
    }],
    staticClass: "voice3Draggable",
    class: _vm.voice3DivClass,
    attrs: {
      "id": "voice3DivID"
    },
    on: {
      "click": _vm.voice3DraggieClick
    }
  }, [_c('strong', [_c('p', {
    attrs: {
      "id": "voiceBubbleText"
    }
  }, [_vm._v("PART 3 ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceBubbleText2"
    }
  }, [_vm._v(" " + _vm._s(_vm.voice3CurrentInstrument) + " ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voice4Div),
      expression: "voice4Div"
    }],
    staticClass: "voice4Draggable",
    class: _vm.voice4DivClass,
    attrs: {
      "id": "voice4DivID"
    },
    on: {
      "click": _vm.voice4DraggieClick
    }
  }, [_c('strong', [_c('p', {
    attrs: {
      "id": "voiceBubbleText"
    }
  }, [_vm._v("PART 4 ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceBubbleText2"
    }
  }, [_vm._v(" " + _vm._s(_vm.voice4CurrentInstrument) + " ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playSunDiv),
      expression: "playSunDiv"
    }],
    staticClass: "playSunDraggable",
    attrs: {
      "id": "playSunDivID"
    },
    on: {
      "click": _vm.playSunDraggieClick
    }
  }, [_c('p', {
    attrs: {
      "id": "sunTextID"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t" + _vm._s(_vm.sunText) + " \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "sunTextID2"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t" + _vm._s(_vm.sunText2) + " \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "sunLoadText1"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t" + _vm._s(_vm.sunLoad1) + " \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "sunLoadText2"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t" + _vm._s(_vm.sunLoad2) + " \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "togetherText"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t" + _vm._s(_vm.allTogetherSunText) + " \n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutDiv),
      expression: "aboutDiv"
    }],
    staticClass: "aboutDraggable",
    attrs: {
      "id": "aboutDivID"
    }
  }, [_c('p', {
    attrs: {
      "id": "createdByHeader"
    }
  }, [_vm._v("\n\t\t\t\t\t\tCREATED BY: \t\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "aboutTextID"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("Matt McCorkle")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.newinc.org",
      "target": "_blank"
    }
  }, [_c('p', {
    attrs: {
      "id": "newINC"
    }
  }, [_vm._v(" (at "), _c('u', [_vm._v("NEW INC")]), _vm._v(") ")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t  \t\t\t\t\t&\n\t\t  \t\t\t\t\t"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "http://www.samreidermusic.com/",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("\n\t\t  \t\t\t\t\tSam Reider ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutDiv),
      expression: "aboutDiv"
    }],
    staticClass: "about2Draggable",
    attrs: {
      "id": "aboutDivID"
    }
  }, [_c('p', {
    attrs: {
      "id": "about2TextID"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tFEATURING:\n\t\t  \t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "about2TextID1"
    }
  }, [_vm._v("\n\t\t  \t\t\t\t\tClarinet: "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "http://markdovermusic.com/",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("\n\t\t  \t\t\t\t\tMark Dover")])]), _vm._v(" "), _c('br'), _vm._v("\n\n\t\t  \t\t\t\t\tViolin & Viola: "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "http://www.alexhargreaves.net",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("\n\t\t  \t\t\t\t\tAlex Hargreaves")])]), _vm._v(" "), _c('br'), _vm._v("\n\n\t\t  \t\t\t\t\tCello: "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "http://www.thebrotherbrothersmusic.com",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("\n\t\t  \t\t\t\t\tDavid Moss")])]), _vm._v(" "), _c('br'), _vm._v("\n\n\t\t  \t\t\t\t\tPiano & Celesta: Sam Reider\n\t\t  \t\t\t\t\t"), _c('br'), _vm._v("\n\t\t  \t\t\t\t\tAccordion: Sam Reider\n\t\t  \t\t\t\t\t"), _c('br'), _vm._v("\n\t\t  \t\t\t\t\tSound Design: Matt McCorkle\n\t\t  \t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t  \t\t\t\t\tSpecial Thanks:\n\t\t  \t\t\t\t\t"), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "http://www.samreidermusic.com/",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("Tone.js")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutDiv),
      expression: "aboutDiv"
    }],
    staticClass: "about3Draggable",
    attrs: {
      "id": "aboutDivID"
    }
  }, [_c('p', {
    attrs: {
      "id": "about3TextHeader"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tABOUT:\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "about3TextID"
    }
  }, [_vm._v(" \n\n\t\t\t\t\t\t\tA harmonious New Year's sound experiment. Harmony has the ability to create rich musical expressions. This project explores harmony and the different textures it creates. Explore all the different instruments performing this four-part harmony.\n\t\t  \t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t  \t\t\t\t\tThis project features Auld Lang Syne arranged in a four-part harmony. Click each revolving orb to reveal a new instrument for each part. Control volume and speed in the MUSIC MIXER section and add seasonal sounds in the AMBIENCES section.\n\t\t  \t\t\t\t\n\t\t  \t\t\t\t\t\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutDiv),
      expression: "aboutDiv"
    }],
    staticClass: "about4Draggable",
    attrs: {
      "id": "aboutDivID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "mailingListText"
    }
  }, [_vm._v(" Stay in touch for new project releases! \n\t\t\t\t\t\t"), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&id=219d3ce36c",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_cc407290614bbaa2daa32fe9e_219d3ce36c",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Subscribe!",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showNavBar) ? _c('div', {
    key: "firstNav",
    staticClass: "col-xs-12",
    attrs: {
      "id": "navBar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn",
    class: _vm.harmonyClass,
    attrs: {
      "id": "harmonizeHeading"
    },
    on: {
      "click": _vm.harmonyMixingPane
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t MUSIC MIXER\t\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "cuteBtn"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn",
    class: _vm.ambianceClass,
    attrs: {
      "id": "ambienceHeading"
    },
    on: {
      "click": _vm.ambianceMixingPane
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t AMBIENCES\n\t\t\t\t\t")])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOutDownBig",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.showHorn) ? _c('div', {
    key: "secondNav",
    staticClass: "col-xs-12",
    attrs: {
      "id": "navBar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    class: _vm.hornClass,
    attrs: {
      "type": "button",
      "id": "hornBtn"
    },
    on: {
      "click": _vm.hornBlow
    }
  }, [_c('p', {
    attrs: {
      "id": "hornBtnPrompt"
    }
  }, [_vm._v("\n\t\t\t\t\t  \t\t\t\tMake Noise \n\t\t\t\t\t  \t\t\t\t"), _c('i', {
    class: _vm.hornStartStopIcon,
    style: ({
      'color': _vm.hornTrigger ? _vm.stopColor : _vm.playColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" While Loading\n\t\t\t\t\t  ")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrompt),
      expression: "showPrompt"
    }],
    staticClass: "col-xs-12"
  }, [_c('p', {
    attrs: {
      "id": "promptText"
    }
  }, [_vm._v("\n\t \t\t\tClick an orb to change instruments on each part of the harmony.\n\t \t\t")]), _vm._v(" "), _c('button', {
    class: _vm.promptButtonClass,
    attrs: {
      "id": "promptButton"
    },
    on: {
      "click": _vm.promptFunc
    }
  }, [_vm._v("Got It "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "white"
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMutePrompt),
      expression: "showMutePrompt"
    }],
    staticClass: "col-xs-12"
  }, [_c('p', {
    attrs: {
      "id": "promptText"
    }
  }, [_c('i', {
    class: _vm.bellSlash
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t    Loading may take a few moments.\n\t\t\t    "), _c('br'), _vm._v(" \n\t\t\t    Please make sure your "), _c('strong', [_vm._v(" mute button is off ")]), _vm._v(" and volume is engaged.\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMissionControl),
      expression: "showMissionControl"
    }],
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voice1Badge",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": _vm.voice1BadgeClick
    }
  }, [_vm._v("PART 1 VOLUME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voice1Radius),
      expression: "voice1Radius"
    }],
    staticClass: "instrument1Ranger",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "": _vm.voice1RadiusFunc,
      "step": "1"
    },
    domProps: {
      "value": (_vm.voice1Radius)
    },
    on: {
      "__r": function($event) {
        _vm.voice1Radius = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voice2Badge",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": _vm.voice2BadgeClick
    }
  }, [_vm._v("PART 2 VOLUME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voice2Radius),
      expression: "voice2Radius"
    }],
    staticClass: "instrument2Ranger",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "": _vm.voice2RadiusFunc,
      "step": "1"
    },
    domProps: {
      "value": (_vm.voice2Radius)
    },
    on: {
      "__r": function($event) {
        _vm.voice2Radius = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voice3Badge",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": _vm.voice3BadgeClick
    }
  }, [_vm._v("PART 3 VOLUME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voice3Radius),
      expression: "voice3Radius"
    }],
    staticClass: "instrument3Ranger",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "": _vm.voice3RadiusFunc,
      "step": "1"
    },
    domProps: {
      "value": (_vm.voice3Radius)
    },
    on: {
      "__r": function($event) {
        _vm.voice3Radius = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voice4Badge",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": _vm.voice4BadgeClick
    }
  }, [_vm._v("PART 4 VOLUME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voice4Radius),
      expression: "voice4Radius"
    }],
    staticClass: "instrument4Ranger",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "": _vm.voice4RadiusFunc,
      "step": "1"
    },
    domProps: {
      "value": (_vm.voice4Radius)
    },
    on: {
      "__r": function($event) {
        _vm.voice4Radius = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "timingSmoosh"
    }
  }, [_c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "daySliderDiv"
    }
  }, [_c('button', {
    attrs: {
      "id": "masterTimingBadges"
    }
  }, [_vm._v("MUSIC VOLUME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.masterVolume),
      expression: "masterVolume"
    }],
    staticClass: "dayRanger",
    attrs: {
      "id": "sliders5",
      "type": "range",
      "": _vm.masterVolumeMixing,
      "max": "12",
      "min": "-30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.masterVolume)
    },
    on: {
      "__r": function($event) {
        _vm.masterVolume = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "timingSliderDiv"
    }
  }, [_c('button', {
    attrs: {
      "id": "masterTimingBadges"
    }
  }, [_vm._v("SPEED")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.masterTiming),
      expression: "masterTiming"
    }],
    staticClass: "timingRanger",
    attrs: {
      "id": "slidersTiming",
      "type": "range",
      "": _vm.masterTimingFunc,
      "max": "0.2",
      "min": "0.02",
      "step": ".0001"
    },
    domProps: {
      "value": (_vm.masterTiming)
    },
    on: {
      "__r": function($event) {
        _vm.masterTiming = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAmbiances),
      expression: "showAmbiances"
    }],
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [_c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience1Func
    }
  }, [_c('i', {
    class: _vm.ambience1Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tPEOPLE\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol"
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "15",
      "min": "-30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience2Func
    }
  }, [_c('i', {
    class: _vm.ambience2Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFIREPLACE\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol"
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "15",
      "min": "-30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience3Func
    }
  }, [_c('i', {
    class: _vm.ambience3Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tWINTER\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol"
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "15",
      "min": "-30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience4Func
    }
  }, [_c('i', {
    class: _vm.ambience4Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tNOISEMAKER\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol"
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "10",
      "min": "-30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceHornDiv"
    }
  }, [_c('button', {
    class: _vm.hornClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.hornBlow
    }
  }, [_c('i', {
    class: _vm.hornStartStopIcon,
    style: ({
      'color': _vm.hornTrigger ? _vm.stopColor : _vm.playColor
    })
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tHORN\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceNoiseDiv"
    }
  }, [_c('button', {
    class: _vm.noisemakerClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.noiseMakerFunc
    }
  }, [_c('i', {
    class: _vm.noisemakerStartStopIcon,
    style: ({
      'color': _vm.noisemakerTrigger ? _vm.stopColor : _vm.playColor
    })
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCLACKER\n\t\t\t\t\t\t\t\t\t\t")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d1a4622","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/harmony.vue
// module id = 20
// module chunks = 0